var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "snapshot-signer-card",
    attrs: {
      "flat": ""
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "width": "100%"
    }
  }, [_c('v-card-actions', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _c('context-menu', [_c('Can', {
    attrs: {
      "I": _vm.ActionEnum.CREATE,
      "a": _vm.ResourceEnum.SNAPSHOT_SIGN_REQUEST,
      "field": _vm.request.partnerId
    }
  }, [_c('v-list-item', {
    on: {
      "click": _vm.sendMail
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-email")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("snapshot.signRequest.send")) + " ")])], 1)], 1)], 1), _c('v-list-item', {
    attrs: {
      "loading": _vm.isSending
    },
    on: {
      "click": _vm.copyUrl
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-content-copy")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("components.CopyClipboardText.copy")) + " ")])], 1)], 1), _c('Can', {
    attrs: {
      "I": _vm.ActionEnum.DELETE,
      "a": _vm.ResourceEnum.SNAPSHOT_SIGN_REQUEST,
      "field": _vm.request.partnerId
    }
  }, [_c('v-list-item', {
    on: {
      "click": _vm.openDeleteDialog
    }
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-delete")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("common.verbs.delete")) + " ")])], 1)], 1)], 1)], 1)], 1)], 1), _c('v-card-subtitle', [_c('div', {
    attrs: {
      "v": ""
    }
  }, [_c('v-img', {
    staticClass: "image-content",
    attrs: {
      "max-width": "100%",
      "aspect-ratio": 195 / 85
    }
  }, [_c('div', {
    staticClass: "d-flex align-center justify-center fill-height",
    staticStyle: {
      "min-height": "30px"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.request.statusIcon) + " ")])], 1)])], 1), _c('div', [_vm.displayedEmail ? _c('b', [_vm._v(_vm._s(_vm.displayedEmail))]) : _vm._e()]), _c('div', [_vm.request.statusReadable ? _c('span', [_vm._v(_vm._s(_vm.request.statusReadable) + ", ")]) : _vm._e(), _vm.displayedDate ? _c('span', [_vm._v(_vm._s(_vm._f("simpleDoubleDigitDate")(_vm.displayedDate)))]) : _vm._e()])]), _vm.isDeleteDialogActive ? _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDeleteDialogActive,
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "title": _vm.$t('delete'),
      "subtitle": _vm.displayedEmail,
      "rightColor": 'error',
      "loading": _vm.isDeleteLoading,
      "rightLoading": _vm.isDeleteLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "close": function close($event) {
        _vm.isDeleteDialogActive = false;
      },
      "leftClick": function leftClick($event) {
        _vm.isDeleteDialogActive = false;
      },
      "rightClick": _vm.onDelete
    }
  }) : _vm._e(), _c('create-snapshot-sign-request-dialog', {
    ref: "createSnapshotSignRequestDialog",
    attrs: {
      "partnerId": _vm.request.partnerId,
      "handoverId": _vm.request.handoverId,
      "snapshotId": _vm.request.snapshotId,
      "snapshot": _vm.snapshot
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }